import { render, staticRenderFns } from "./CampaignRewardMessage.vue?vue&type=template&id=4a035754&"
import script from "./CampaignRewardMessage.vue?vue&type=script&lang=js&"
export * from "./CampaignRewardMessage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports